// import { SuccessRequestAction } from "../../Redux/Middleware/apiMiddleware";
import { AnnotationsAction, UpdateFakeAnnotation } from "../actions";
import { ActionTypes } from "../const/ActionTypes";
import { AnnotationItemExtended, Annotations } from "../types";

export type AnnotationsState = Annotations;

const replaceFakeData = (state: AnnotationItemExtended[], action: UpdateFakeAnnotation) =>
    state.map(item =>
        item.data.id === action.annotationItem.data.id
            ? {
                  ...item,
                  data: { ...item.data },
                  message: {
                      ...item.message,
                      messageId: action.messageInfo.MessageId,
                      date: action.messageInfo.Date,
                      userId: action.messageInfo.UserId,
                      userName: action.messageInfo.UserName,
                      canEdit: action.messageInfo.CanEdit,
                      canDelete: action.messageInfo.CanDelete,
                  },
                  annotationId: action.annotationId,
              }
            : item
    );

const updateAnnotation = (state: AnnotationItemExtended[], annotation: AnnotationItemExtended) =>
    state.map(item =>
        item.annotationId === annotation.annotationId
            ? { ...item, data: { ...item.data, text: annotation.data.text } }
            : item
    );

const mouseEnterAnnotation = (state: AnnotationItemExtended[], annotation: AnnotationItemExtended) =>
    state.map(item =>
        item.annotationId === annotation.annotationId ? { ...item, data: { ...item.data, hover: true } } : item
    );

const mouseLeaveAnnotation = (state: AnnotationItemExtended[]) =>
    state.map(item => (item.data.hover ? { ...item, data: { ...item.data, hover: false } } : item));

const deleteAnnotation = (
    state: AnnotationItemExtended[],
    annotation: AnnotationItemExtended
): AnnotationItemExtended[] => state.filter(item => item.annotationId !== annotation.annotationId);

export const annotationsReducer = (state: AnnotationsState = {}, action: AnnotationsAction) => {
    switch (action.type) {
        case ActionTypes.CLEAR_ANNOTATIONS:
            return {};
        case ActionTypes.SET_INITIAL_ANNOTATIONS:
            return action.value;
        case ActionTypes.SET_ANNOTATIONS:
            return { ...state, ...action.value };
    }

    if (action.attachmentId) {
        return {
            ...state,
            [action.attachmentId]: annotationsReducerImpl(state[action.attachmentId], action),
        };
    }

    return state;
};

export const annotationsReducerImpl = (
    state: AnnotationItemExtended[] = [],
    action: AnnotationsAction
): AnnotationItemExtended[] => {
    switch (action.type) {
        case ActionTypes.ADD_ANNOTATION:
            const annotations = [...state];
            annotations.push(action.value);
            return annotations;
        case ActionTypes.UPDATE_ANNOTATION:
            return updateAnnotation(state, action.value);
        case ActionTypes.UPDATE_MESSAGE:
            return updateAnnotation(state, action.value);
        case ActionTypes.MOUSE_ENTER_ANNOTATION:
            return mouseEnterAnnotation(state, action.value);
        case ActionTypes.MOUSE_LEAVE_ANNOTATION:
            return mouseLeaveAnnotation(state);
        case ActionTypes.DELETE_ANNOTATION:
            return deleteAnnotation(state, action.value);
        case ActionTypes.DELETE_MESSAGE:
            return deleteAnnotation(state, action.value);
        case ActionTypes.UPDATE_FAKE_ANNOTATION:
            return replaceFakeData(state, action);
        default:
            return state;
    }
};
